class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.notifHeading = document.querySelector('h2.cart-notification__heading');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );

    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.notification.classList.add('active','animate');
      this.notifHeading.classList.add('visibility-hidden');
      //this.open();
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.notification.classList.add('active','animate');
        this.notifHeading.classList.add('visibility-hidden');
        //this.open();
      }
    });
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {

  this.cartItemKey = parsedState.key;

  this.getSectionsToRender().forEach((section) => {
    document.getElementById(section.id).innerHTML =
      this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
  });

  // The notification now contains products.
  this.classList.remove("is-empty");

  if (this.header) this.header.reveal();

  this.open();
}

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification',
        selector: '.cart-notification',
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);

class CartNotificationItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartNotification',
        section: 'cart-notification',
        selector: '.cart-notification'
      },
      {
        id: 'cart-notification-button',
        section: 'cart-notification-button',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}
customElements.define('cart-notification-items', CartNotificationItems);